import type { CommunityListGlobal, Profile } from 'models';
import { canManageCommunityProfile } from './can-manage-community';

export const canInviteToCommunityProfile = ({
  community,
  viewer,
}: {
  community: CommunityListGlobal;
  viewer: Profile;
}) => community.privacy === 'public' || canManageCommunityProfile({ community, viewer });
